import { shuffle, difference, keys } from 'lodash';
const Crash = require("crash-colliders");

class CollisionBoxSystem {
  constructor(systems) {
    this.systems = systems;
    if (typeof(Crash) !== 'undefined') {
      this.crash = new Crash({
        overlapLimit:0.5/100
      });
      this.crash.onCollision(this.onCrashCollision.bind(this));
    }
    this.collisionBoxCache = {};
    this.__collisionBoxCacheLen = 0;
    this.CURRENTLY_COLLIDING = {};
    this.__CURRENT_COLLIDING_LEN = 0;
  }


  before(dt) {
    if (!this.crash) {
      return;
    }
    this.collisionHitKeys = [];
    this.alreadyProcessedCrashCollision = {};
  }

  after(dt) {
    if (!this.crash) {
      return;
    }
    const hitKeys = this.collisionHitKeys;
    if (this.__collisionBoxCacheLen !== hitKeys.length) {
      const toRemove = difference(keys(this.collisionBoxCache), hitKeys);
      const toRemoveLength = toRemove.length;
      const left = this.crash.all();
      for (let i = 0; i < toRemoveLength; i++) {
          const uuid = toRemove[i];
          this.crash.remove(this.collisionBoxCache[uuid]);
          delete this.collisionBoxCache[uuid];
          this.__collisionBoxCacheLen--;
      }
    }

    if (hitKeys.length && !this.addCollisionBoxesToPhysicsBodies) {
      this.systems.addCollisionBoxesToPhysicsBodies = true;
      const ents = this.systems.gameobjects.entities.querySystem(this.systems.Components.PhysicsBody);
      for (let i = 0; i < ents.length; i++) {
        const ent = ents[i];
        this.systems.forceSetDirty(ent);
      }
    }


    // do the collision thingy here
    //this.gameobjects.b2d_collisionsBegin = [];
    //this.gameobjects.b2d_collisionsEnd = [];

    this.NEW_CURRENTLY_COLLIDING = {};
    this.__NEW_CURRENTLY_COLLIDING_LEN = 0;
    this.crash.check();

    if (this.__CURRENT_COLLIDING_LEN !== this.__NEW_CURRENTLY_COLLIDING_LEN) {
      const stoppedColliding = difference(keys(this.CURRENTLY_COLLIDING), keys(this.NEW_CURRENTLY_COLLIDING));
      const stoppedCollidingLength = stoppedColliding.length;
      for (let i = 0; i < stoppedCollidingLength; i++) {
        const stoppedKey = stoppedColliding[i];
        const stopped = this.CURRENTLY_COLLIDING[stoppedKey];
        const {entA,entB, entACollisionWith, entBCollisionWith} = stopped;
        if (entA && entA.uuid && entB && entB.uuid) {
          for (let j = this.systems.gameobjects.b2d_collisionsBusy.length - 1; j >= 0; j--) {
            const collisionBusy = this.systems.gameobjects.b2d_collisionsBusy[j];
            const busyEntA = collisionBusy.entA;
            const busyEntB = collisionBusy.entB;
            if (!busyEntA.uuid || !busyEntB.uuid) {
              this.systems.gameobjects.b2d_collisionsBusy.splice(j, 1);
              this.systems.setEntityStoppedColliding(entA, entB);
              this.systems.setEntityStoppedColliding(entB, entA);
            } else {
              if ((entA.uuid.uuid === busyEntA.uuid.uuid && entB.uuid.uuid === busyEntB.uuid.uuid) || (entA.uuid.uuid === busyEntB.uuid.uuid && entB.uuid.uuid === busyEntA.uuid.uuid)) {
                this.systems.gameobjects.b2d_collisionsBusy.splice(j, 1);
                this.systems.setEntityStoppedColliding(entA, entB);
                this.systems.setEntityStoppedColliding(entB, entA);
                this.systems.gameobjects.b2d_collisionsEnd.push({
                  entA, entB, entACollisionWith, entBCollisionWith
                })

              }
            }
          }
        }
      }
    }

    this.CURRENTLY_COLLIDING = this.NEW_CURRENTLY_COLLIDING;
    this.__CURRENT_COLLIDING_LEN = this.__NEW_CURRENTLY_COLLIDING_LEN;


    this.checkForCollisions(dt);
  }

  update(dt, ent) {
    if (!this.crash) {
      return;
    }

    if (!this.systems.isCameraReady(ent)) {
      return
    }
    if (!this.systems.isContainersReady(ent)) {
      return;
    }


    const totalLength = ent.collisionBox.multi.length;

    const transform = ent.transform;

    const worldPos = this.systems.getWorldPosition(ent);
    const worldScale = this.systems.getWorldScale(ent);

    for (let j = 0; j < totalLength; j++) {
      const o = ent.collisionBox.multi[j];
      const collisionBox = o.c;
      const component = o.component;

      const colliderKey = ent.uuid.uuid + '-' + component.id;
      let collider = this.collisionBoxCache[colliderKey];
      //const width = 100;
      //const height = 100;

      if (collider && !this.systems.isDirty(ent)) {
        this.collisionHitKeys.push(colliderKey);
        continue;
      }
      this.collisionHitKeys.push(colliderKey);

      const width = Math.abs(collisionBox.scalex * worldScale.x);
      const height = Math.abs(collisionBox.scaley * worldScale.y);
      if (collider && (collisionBox.lastScale && Math.abs(worldScale.x - collisionBox.lastScale.x) > 0.001 && Math.abs(worldScale.y - collisionBox.lastScale.y) > 0.0001)) {
        this.crash.remove(collider);
        delete this.collisionBoxCache[colliderKey];
        this.__collisionBoxCacheLen--;
        collisionBox.lastScale = {
          x:worldScale.x,
          y:worldScale.y,
        }

        if (Math.abs(width) > 0.01 && Math.abs(height) > 0.01) {
          collider = new this.crash.Box(
            new this.crash.Vector(
              worldPos.x - width*transform.anchorx,
              worldPos.y - height*transform.anchory
            ),
            width,
            height
          );
          collider.data = {
            ent
          }
          this.crash.insert(collider);
          this.collisionBoxCache[colliderKey] = collider;
          this.__collisionBoxCacheLen++;
         }
      }
      //if (!collider || (collisionBox.lastScale && Math.abs(worldScale.x - collisionBox.lastScale.x) > 0.001 && Math.abs(worldScale.y - collisionBox.lastScale.y) > 0.0001)) {
      if (!collider) {

        ent.addTag(component.id);
        if (collisionBox.tag) {
          ent.addTag(collisionBox.tag);
        }

        if (collider) {
          this.crash.remove(collider);
          this.collisionBoxCache[colliderKey] = null;
        }
        if (Math.abs(width) > 0.01 && Math.abs(height) > 0.01) {
          collider = new this.crash.Box(
            new this.crash.Vector(
              worldPos.x - width*transform.anchorx,
              worldPos.y - height*transform.anchory
            ),
            width,
            height
          );
          collider.data = {
            ent
          }

          this.systems.addComponent(ent, this.systems.findSlots(ent, component, 'link'));


          this.crash.insert(collider);
          this.collisionBoxCache[colliderKey] = collider;
          this.__collisionBoxCacheLen++;
          collisionBox.lastx = worldPos.x + 9999;
          collisionBox.lasty = worldPos.y + 9999;
          collisionBox.lastScale = {
            x:worldScale.x,
            y:worldScale.y,
          }

          if (this.systems.gameobjects.DEBUG_DRAW) {
            this.systems.Components.Shape.create(ent, 'rectangle', shuffle(''+[0xff0000,0x00ff00,0x0000ff,0xff00ff, 0xffff00, 0x00ffff])[0], 10);
          }
        } else {
          console.warn('collision box has no size, ignoring...');
        }

      }

      collider = this.collisionBoxCache[colliderKey]
      if (collider && ( Math.abs(collisionBox.lastx - worldPos.x) > 0.01 || Math.abs(collisionBox.lasty - worldPos.y) > 0.01)) {
        const worldScale = this.systems.getWorldScale(ent);
        const myScale = {
          x:Math.max(0.05,worldScale.x),
          y:Math.max(0.05,worldScale.y),
        }

        collider.moveTo(
            worldPos.x - width*transform.anchorx, 
            worldPos.y - height*transform.anchory
        );
        //collider.setAngle(transform.rotation)
        collisionBox.lastx = worldPos.x;
        collisionBox.lasty = worldPos.y;
      }

    }


    //this.checkForCollisions(dt);

  //  this.debug.stopSystem('updateCollisionBoxes');
  }

  checkForCollisions(dt) {
    if (!this.systems.gameobjects.b2d_collisionsBegin || !this.systems.gameobjects.b2d_collisionsBusy || !this.systems.gameobjects.b2d_collisionsEnd) {
      //console.error('lol', this.gameobjects.b2d_collisionsBegin, this.gameobjects.b2d_collisionsBusy, this.gameobjects.Box2D);
      return;
    }
    let done = {};
    let total = this.systems.gameobjects.b2d_collisionsEnd.length;
    for (let i = 0; i < total; i++) {
      const collisionEnd = this.systems.gameobjects.b2d_collisionsEnd[i];
      const {entACollisionWith,entBCollisionWith} = collisionEnd;
      const entA = collisionEnd.entA;
      const entB = collisionEnd.entB;
      if (!entA || !entB || !entA.uuid || !entB.uuid) {
        continue;
      }
      //const key = `${entA.uuid.uuid}-${entB.uuid.uuid}`;
      //if (done[key]) {
        //continue;
      //}
      this.systems.gameobjects.debugLog({
        ent:entA,
        component:{},
        type:'debug',
        line:`Collision: End ${entB.uuid.uuid}`
      })

      if (entA && entACollisionWith && entB) {
        this.doCollisionWith(entA, entB, 'end', collisionEnd, entACollisionWith);
      }
      if (entA && entB && entBCollisionWith) {
        this.doCollisionWith(entB, entA, 'end', collisionEnd, entBCollisionWith);
      }
    }

    total = this.systems.gameobjects.b2d_collisionsBegin.length;
    if (total > 0) {
      //console.log('collisions begin', total);
    }
    done = {};
    for (let i = 0; i < total; i++) {
      const collisionBegin = this.systems.gameobjects.b2d_collisionsBegin[i];
      const {entACollisionWith,entBCollisionWith} = collisionBegin;
      const entA = collisionBegin.entA;
      const entB = collisionBegin.entB;
      if (!entA || !entB || !entA.uuid || !entB.uuid) {
        //console.warn('no uuid found');
        continue;
      }
      //const key = `${entA.uuid.uuid}-${entB.uuid.uuid}`;
      //if (done[key]) {
        //console.warn('already done');
        //continue;
      //}
      //done[key] = true;
      this.systems.gameobjects.debugLog({
        ent:entA,
        component:{},
        type:'debug',
        line:`Collision: Begin ${entB.uuid.uuid}`
      })

      if (entA && entACollisionWith && entB) {
        this.doCollisionWith(entA, entB, 'begin', collisionBegin, entACollisionWith);
      }

      if (entA && entB && entBCollisionWith) {
        this.doCollisionWith(entB, entA, 'begin', collisionBegin, entBCollisionWith);
      }
    }

    done = {};
    total = this.systems.gameobjects.b2d_collisionsBusy.length;
    if (total > 0) {
      //console.log('collisions busy', total);
    }
    for (let i = 0; i < total; i++) {
      const collisionBusy = this.systems.gameobjects.b2d_collisionsBusy[i];
      const {entACollisionWith,entBCollisionWith} = collisionBusy;
      const entA = collisionBusy.entA;
      const entB = collisionBusy.entB;
      //const key = `${entA.uuid.uuid}-${entB.uuid.uuid}`;
      //if (done[key]) {
        //continue;
      //}

      if (entA && entACollisionWith && entB) {
        this.doCollisionWith(entA, entB, 'busy', collisionBusy, entACollisionWith);
      }
      if (entA && entB && entBCollisionWith) {
        this.doCollisionWith(entB, entA, 'busy', collisionBusy, entBCollisionWith);
      }
    }

  }

  doCollisionWith(entA, entB, name, collisionData, collisionWiths) {
    const totalLength = collisionWiths.multi.length;
    for (let j = 0; j < totalLength; j++) {
      const o = collisionWiths.multi[j];

      const collisionWith = o.c;
      const component = o.component;
      let hasAnyTag = false;
      let firstFoundTag;
      for (var k = 0; k < collisionWith.tags.length; k++) {
        let tag = collisionWith.tags[k];
        hasAnyTag = hasAnyTag || entB.hasTag(tag);
        if (hasAnyTag) {
          firstFoundTag = firstFoundTag || tag;
        }
      }
      if (!hasAnyTag) {
        continue;
      }
      let tag = firstFoundTag;
      const entTag = tag + '-' + entB.uuid.uuid;
      const tagTag = tag;
      const onlyOnce = collisionWith.onceOnly && (collisionWith.alreadyCollided[entTag] || (collisionWith.onceOnlyTag && collisionWith.alreadyCollided[tagTag]));
      if (onlyOnce) {
        continue;
      }
      collisionWith.alreadyCollided[entTag] = true;
      collisionWith.alreadyCollided[tagTag] = true;
      //this.debug.addDebugLine(entA, 'collide with: ' + entB._tags.join(','));
      const props = this.systems.getProperties(entA);
      this.systems.addComponent(entA, this.systems.findSlots(entA, component, name));
      this.systems.addComponent(entB, this.systems.findSlots(entB, component, `${name}Other`), undefined, props);
    }

  }

  onCrashCollision(a, b, res, cancel) {
    const entA = a.data.ent;
    const entB = b.data.ent;
    if (!entA.uuid || !entB.uuid) {
      return;
    }
    const collisionHash = entA.uuid.uuid < entB.uuid.uuid ? (entA.uuid.uuid + '-' + entB.uuid.uuid) : (entB.uuid.uuid + '-' + entA.uuid.uuid);
    if (this.alreadyProcessedCrashCollision[collisionHash]) {
      return;
    }
    this.alreadyProcessedCrashCollision[collisionHash] = true;
    if (entA.physicsbody && entB.physicsbody) {
      // box2d will handle this collision... we step away
      return;
    }
    const collisionKey = entA.uuid.uuid + '-' + entB.uuid.uuid;
    const entACollisionWith = this.systems.findComponentInTree(entA, 'collisionWith');
    const entBCollisionWith = this.systems.findComponentInTree(entB, 'collisionWith');
    const collisionObject = {
      entA,
      entB,
      entACollisionWith,
      entBCollisionWith
    }

    if (!this.CURRENTLY_COLLIDING[collisionKey]) {
      this.NEW_CURRENTLY_COLLIDING[collisionKey] = {
        entA,
        entACollisionWith,
        entBCollisionWith,
        entB
      }
      this.__NEW_CURRENTLY_COLLIDING_LEN++;
      //console.log('collision key', collisionKey);
      this.systems.gameobjects.b2d_collisionsBegin.push(collisionObject);
      this.systems.gameobjects.b2d_collisionsBusy.push(collisionObject);
    } else {
      this.NEW_CURRENTLY_COLLIDING[collisionKey] = this.CURRENTLY_COLLIDING[collisionKey]
      this.__NEW_CURRENTLY_COLLIDING_LEN++;
    }


    this.systems.setEntityBusyColliding(entA, entB);
    this.systems.setEntityBusyColliding(entB, entA);
  }

  getCollisionBox(x, y, w, h) {
    return new this.crash.Box(
      new this.crash.Vector(x,y),
      w, h
    )
  }

}
export default CollisionBoxSystem;
